import {
  PostApiSpoAvailableFiltersBody,
  SpoAvailableFiltersResponse,
} from '@spo/types';
import { apiBff } from '.';

export const getAvailableFilters = async (
  postApiSpoAvailableFiltersBody: PostApiSpoAvailableFiltersBody,
): Promise<SpoAvailableFiltersResponse> =>
  apiBff.callBFF(
    'POST',
    'spo/available_filters',
    postApiSpoAvailableFiltersBody,
  );
